<template>
	<div class="sf-datatable-wrapper">
		<div class="sf-datatable-container">
			<div class="sf-table">
				<table class="qms-table">
					<tbody>
						<tr>
							<th class="col-1">사용여부코드</th>
							<td class="col-1">
								<el-input v-model="commCdCd" />
								<span class="unit input-icon"><i class="icon-sf-search" @click="() => onUserPopup('USE_YN')" /></span>
							</td>
							<th class="col-1">LINE_CD</th>
							<td class="col-1">
								<el-input v-model="lineCdCd" />
								<span class="unit input-icon"><i class="icon-sf-search" @click="() => onUserPopup('LINE_CD')" /></span>
							</td>
							<th class="col-1">FACTORY_CD</th>
							<td class="col-1">
								<el-input v-model="factoryCdCd" />
								<span class="unit input-icon"><i class="icon-sf-search" @click="() => onUserPopup('FACTORY_CD')" /></span>
							</td>
						</tr>
						<tr>
							<th class="col-1">lineCd.commCdType</th>
							<td class="col-1">
								<el-input :value="lineCd.commCdType" />
							</td>
							<th class="col-1">lineCd.commCd</th>
							<td class="col-1">
								<el-input :value="lineCd.commCd" />
							</td>
							<th class="col-1">lineCd.commCdName</th>
							<td class="col-1">
								<el-input :value="lineCd.commCdName" />
							</td>
							<th class="col-1">factoryCd.commCd</th>
							<td class="col-1">
								<el-input :value="factoryCd.commCd" />
							</td>
							<th class="col-1">factoryCd.commCdName</th>
							<td class="col-1">
								<el-input :value="factoryCd.commCdName" />
							</td>
						</tr>
						<tr>
							<th class="col-1">factoryCd.commCdType</th>
							<td class="col-1">
								<el-input :value="factoryCd.commCdType" />
							</td>
							<th class="col-1">commCd.commCdType</th>
							<td class="col-1">
								<el-input :value="commCd.commCdType" />
							</td>
							<th class="col-1">commCd.commCdName</th>
							<td class="col-1">
								<el-input :value="commCd.commCdName" />
							</td>
							<th class="col-1">commCd.commCd</th>
							<td class="col-1">
								<el-input :value="commCd.commCd" />
							</td>
							<th class="col-1">refCd2</th>
							<td class="col-1">
								<el-input :value="commCd.refCd2" />
							</td>
						</tr>
						<tr>
							<th class="col-1">refCd3</th>
							<td class="col-1">
								<el-input :value="commCd.refCd3" />
							</td>
							<th class="col-1">refCd4</th>
							<td class="col-1">
								<el-input :value="commCd.refCd4" />
							</td>
							<th class="col-1">refCd5</th>
							<td class="col-1">
								<el-input :value="commCd.refCd" />
							</td>
						</tr>
						<tr>
							<th class="col-1">refCd3</th>
							<td class="col-1">
								<el-input :value="commCd.refCd3" />
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../store/helpers';
import * as yup from 'yup';
export default {
	data() {
		return {
			//생산업체 검색 저장하는 객체
			didGetCommCdCd: false,
			commCdCd: '',
			commCd: {
				commCdType: 'USE_YN',
				commCdTypeName: '',
				mstUseYn: '',
				commCdTypeSort: '',
				commCd: '',
				commCdName: '',
				commCdSeq: '',
				useYn: '',
				refCd1: '',
				refCd2: '',
				refCd3: '',
				refCd4: '',
				refCd5: ''
			},
			didGetLineCdCd: false,
			lineCdCd: '',
			lineCd: {
				commCdType: 'LINE_CD',
				commCdTypeName: '',
				mstUseYn: '',
				commCdTypeSort: '',
				commCd: '',
				commCdName: '',
				commCdSeq: '',
				useYn: '',
				refCd1: '',
				refCd2: '',
				refCd3: '',
				refCd4: '',
				refCd5: ''
			},
			didGetFactoryCdCd: false,
			factoryCdCd: '',
			factoryCd: {
				commCdType: 'FACTORY_CD',
				commCdTypeName: '',
				mstUseYn: '',
				commCdTypeSort: '',
				commCd: '',
				commCdName: '',
				commCdSeq: '',
				useYn: '',
				refCd1: '',
				refCd2: '',
				refCd3: '',
				refCd4: '',
				refCd5: ''
			}
		};
	},
	props: {
		scrId: { type: String, default: '' },
		sendParam: { type: Object }
	},
	created() {},
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		onUserPopup(param) {
			//this.compPopupParams.cmpnScn = param;
			//console.log('SearchView에서 onUserPopup 실행', param);
			if (param === 'USE_YN') {
				//console.log(' USE_YN SearchView에서 onUserPopup 실행', param);
				this.commCdCd = this.commCd.commCd;
				this.$emit('OpenPopupCommCode', this.commCd);
				//console.log(' this.commCd SearchView에서 onUserPopup 실행', this.commCd);
			} else if (param === 'LINE_CD') {
				this.lineCdCd = this.lineCd.commCd;
				//console.log(' LINE_CD SearchView에서 onUserPopup 실행', param);
				this.$emit('OpenPopupCommCode', this.lineCd);
			} else if (param === 'FACTORY_CD') {
				this.factoryCdCd = this.factoryCd.commCd;
				//console.log('FACTORY_CD SearchView에서 onUserPopup 실행', param);
				this.$emit('OpenPopupCommCode', this.factoryCd);
			}
		}
	},
	watch: {
		sendParam(newValue, oldValue) {
			//console.log('watch 실행', this.sendParam);
			if (this.sendParam.commCdType == 'USE_YN') {
				//console.log('watch 실행 commCd', this.sendParam.commCdType);
				this.commCd = this.sendParam;
				this.commCdCd = this.sendParam.commCd;
				this.didGetCommCdCd = true;
			} else if (this.sendParam.commCdType == 'LINE_CD') {
				//console.log('watch 실행 manuCmpn', this.sendParam.commCdType);
				this.lineCd = this.sendParam;
				this.lineCdCd = this.sendParam.commCd;
				this.didGetLineCdCd = true;
			} else {
				//console.log('watch 실행 factoryCd', this.sendParam.commCdType);
				this.factoryCd = this.sendParam;
				this.factoryCdCd = this.sendParam.commCd;
				this.didGetFactoryCdCd = true;
			}
		},
		commCdCd(newValue, oldValue) {
			if (!this.didGetCommCdCd) {
				this.commCd = {
					commCdType: 'USE_YN',
					commCdTypeName: '',
					mstUseYn: '',
					commCdTypeSort: '',
					commCd: this.commCdCd,
					commCdName: '',
					commCdSeq: '',
					useYn: '',
					refCd1: '',
					refCd2: '',
					refCd3: '',
					refCd4: '',
					refCd5: ''
				};
			} else {
				this.didGetCommCdCd = false;
			}
		},
		lineCdCd(newValue, oldValue) {
			if (!this.didGetLineCdCd) {
				this.lineCd = {
					commCdType: 'LINE_CD',
					commCdTypeName: '',
					mstUseYn: '',
					commCdTypeSort: '',
					commCd: this.lineCdCd,
					commCdName: '',
					commCdSeq: '',
					useYn: '',
					refCd1: '',
					refCd2: '',
					refCd3: '',
					refCd4: '',
					refCd5: ''
				};
			} else {
				this.didGetLineCdCd = false;
			}
		},
		factoryCdCd(newValue, oldValue) {
			if (!this.didGetFactoryCdCd) {
				this.factoryCd = {
					commCdType: 'FACTORY_CD',
					commCdTypeName: '',
					mstUseYn: '',
					commCdTypeSort: '',
					commCd: this.factoryCdCd,
					commCdName: '',
					commCdSeq: '',
					useYn: '',
					refCd1: '',
					refCd2: '',
					refCd3: '',
					refCd4: '',
					refCd5: ''
				};
			} else {
				this.didGetFactoryCdCd = false;
			}
		}
	}
};
</script>
